export enum Player {
  Player1 = 'player1',
  Player2 = 'player2',
}